<template>
  <div
    class="biChartWrap biLineWrap"
    ref="biLineWrap">
    <svg
      ref="svg"
      v-if="data && data.length"
      :width="clientWidth"
      :height="clientHeight"
      :class="{'biChartBlur': refresh !== 0}">
      <g
        class="cities"
        ref="cities"/>
      <g class="label">
        <rect
          fill="url(#linearColor)"
          width="10"
          height="150"
          :y="bottom - 150 + 2"
          stroke="#ccc"/>
      </g>
      <text
        class="title"
        :x="clientWidth / 2"
        :y="bottom"
        text-anchor="middle">{{ title }}</text>
      <defs>
        <linearGradient
          id="linearColor"
          x1="0"
          y1="0"
          x2="0"
          y2="100%">
          <stop
            offset="0"
            :style="{'stop-color' : getColor(max)}"/>
          <stop
            offset="100%"
            :style="{'stop-color' : getColor(0)}"/>
        </linearGradient>
      </defs>
    </svg>
    <div
      class="center-p"
      v-show="refresh === 0 && !(classes.data.length) || refresh === 1 || refresh === 2 || refresh === 3">
      <el-tag type="warning"><i
        class="el-icon-loading"
        v-show="refresh === 1"/>{{ message[refresh] }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        @click="reload"
        v-show="refresh === 0">
        <i class="el-icon-refresh"/>点击刷新
      </el-button>
    </div>
    <bi-tool-tip
      class="tooltip"
      ref="tooltip"
      :data="tooltip"/>
  </div>
</template>

<script>
import * as d3 from 'd3';
import Common from '@/components/charts/common';
import mapChina from '@/components/charts/mapChina';

export default {
  mixins: [Common],
  data() {
    return {
      init: false,
      defaultOptions: {
        width: 0,
        height: 0,
        margin: {
          top: 50, right: 24, bottom: 20, left: 45
        },
        duration: 400,
        maxColorPoint: 1,
        colors: ['#A7F5FF', '#0030FF']
      },
    };
  },
  props: {
    title: { type: String, default: '' },
  },
  computed: {
    map() {
      // let width = this.right - this.left;
      // let height = this.bottom - this.top;
      // console.log(width, height);
      // const P = 1.354; // 地图比例
      // let min = d3.min([width, height]);
      // console.log(min);
      // if (min === width) {
      //   min = min / 1.354;
      // }
      // if (min === height) {
      //   if (height * P < width) {
      //     console.log('height');
      //     min = (height * P) / 1.067;
      //   } else {
      //     console.log('width');
      //     min = width * 0.788;
      //   }
      // }
      // console.log(min);
      return d3.geoMercator()
        .fitExtent([[this.left, this.top], [this.innerWidth, this.innerHeight]], mapChina);
      // return d3
      //   .geoMercator()
      //   .center([102.5, 38])
      //   .scale(min)
      //   .translate([(width / 2) + this.left, (height / 2) + this.top]);
    },
    path() {
      return d3.geoPath()
        .projection(this.map);
    },
    extent() {
      return d3.extent(this.data, (d) => {
        let current = mapChina.features.find((item) => {
          return item.properties.id === d.label;
        });
        return current ? d.value : 0;
      });
    },
    max() {
      return d3.max(this.extent);
    }
  },
  methods: {
    getColor(value) {
      let t = (value / this.max) * this.option.maxColorPoint;
      let colors = d3.interpolate(d3.color(this.option.colors[0]), d3.color(this.option.colors[1]));
      return d3.rgb(colors(t));
    },
    initializeMap() {
      // this.path;
      d3
        .select('.cities')
        .selectAll('path')
        .data(mapChina.features)
        .enter()
        .append('path')
        .attr('stroke', this.getColor(this.max / 2))
        .attr('stroke-width', 1)
        .attr('fill', (d) => {
          let id = d.properties.id;
          let current = this.data.find((item) => {
            return item.label === id;
          });
          return this.getColor(current ? current.value : 0);
        })
        .attr('d', this.path)
        .on('mouseover', (d, i, t) => {
          d3
            .select(t[i])
            .attr('fill', (d) => {
              let id = d.properties.id;
              let current = this.data.find((item) => {
                return item.label === id;
              });
              return this.getColor(current ? current.value : 0).brighter(0.1);
            });

          this.opacityFocus(1);
        })
        .on('mouseout', (d, i, t) => {
          d3
            .select(t[i])
            .attr('fill', (d) => {
              let id = d.properties.id;
              let current = this.data.find((item) => {
                return item.label === id;
              });
              return this.getColor(current ? current.value : 0);
            });

          this.opacityFocus(0);
        })
        .on('mousemove', (d, i, t) => {
          let current = this.data.find((item) => {
            return item.label === d.properties.id;
          });
          let curVal = current ? current.value : 0;
          this.tooltip = {
            title: `${d.properties.name}用户总计`,
            desc: [{
              status: true,
              type: 'bar',
              title: d.properties.name,
              value: curVal,
              color: this.getColor(curVal)
            }],
            x: d3.mouse(t[i])[0] + 20,
            y: d3.mouse(t[i])[1],
            panelWidth: this.clientWidth
          };
        });
      this.initLabel();
    },
    initLabel() {
      let y = d3.scaleLinear()
        .domain(this.extent)
        .rangeRound([this.bottom, this.bottom - 150]);
      let label = d3
        .select(this.$refs.biLineWrap)
        .select('.label')
        .attr('transform', 'translate(60, 0)');
      label
        .call(d3.axisLeft(y)
          .ticks(10))
        .select('.domain')
        .remove();
    },
    opacityFocus(opacity) {
      d3
        .select(this.$refs.biLineWrap)
        .select('.tooltip')
        .transition()
        .duration(this.duration / 2)
        .style('opacity', opacity || 0);
    },
  },
  watch: {
    data() {
      this.option.classes && this.$nextTick(() => {
        this.classes.data = this.option.classes.map((d) => {
          return {
            title: d,
            status: true,
            view: true
          };
        });
        this.initializeMap();
      });
    }
  }
};
</script>

<style>
.biLineWrap {
  position: relative;
  height: 100%;
}

.biChartBlur {
  opacity: .25;
  filter: blur(12px);
}

.biLineWrap svg {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.biLineWrap line {
  shape-rendering: crispEdges;
}

.biLineWrap .axis path,
.biLineWrap .axis line {
  fill: none;
  stroke: black;
  shape-rendering: crispEdges;
}

.biLineWrap .focusLine rect {
  fill: none;
  pointer-events: all;
}

.biLineWrap .focusLine line {
  stroke: #666;
  stroke-dasharray: 2, 1;
  pointer-events: none;
}

.biLineWrap .focusLine circle {
  stroke: #333;
  pointer-events: none;
}

.biLineWrap .center-p {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
